module.exports = __webpack_public_path__ + "static/x86.b8ad9ae8.png";